import { Layout } from "./ui/layouts/Layout/Layout.client"

!(async () => {
  Layout()
})()